import onePlatformGetMultipleServicesAvailable from './onePlatformGetMultipleServicesAvailable';
import onePlatformGetServiceQualification from './onePlatformGetServiceQualification';
/**
 * Determines the service availability for the selected address.
 *
 * @param {Object} onePlatformServiceQualification
 *   The returned SQ object.
 * @return {Promise<Response|boolean>}
 *   The object received.
 */
const onePlatformCheckServicesAvailable = (onePlatformServiceQualification) => {
    const { compositeAddress } = onePlatformServiceQualification;
    try {
        if (Object.prototype.toString.call(compositeAddress) === '[object Array]') {
            if (compositeAddress.length > 1) {
                return onePlatformGetMultipleServicesAvailable(compositeAddress);
            }
            else {
                return onePlatformGetServiceQualification(compositeAddress[0]);
            }
        }
    }
    catch (error) {
        console.log('Error:', error);
    }
};
export default onePlatformCheckServicesAvailable;
